module.exports = __webpack_public_path__ + "static/media/baby-preto.a11a3069.jpg";